import request from '@/utils/request';

//我的试卷
export async function upQuestionApi(params: any): Promise<any> {
  return request(`/api/v1/pb/exams`, {
    method: 'post',
    data: params,
  });
}
